module.exports = __webpack_public_path__ + "static/img/CU.a846d5f5.png";